import moment from 'moment';

class TeamRequestCoincidencesMobileController {

  constructor(teamRequestsService, vacationUserDataService, loadingMobileService) {
    'ngInject';
    this.teamRequestsService = teamRequestsService;
    this.managerId = vacationUserDataService.getEmployee().userId;
    this.loadingMobileService = loadingMobileService;

    this.loaded = false;
    this.coincidences = [];
  }

  $onInit() {
    this.loadingMobileService.show();
    this.request.endDate = this.request.endDate || moment().format('YYYY-MM-DD');
    this.teamRequestsService.getCoincidences(
      this.managerId,
      this.request.startDate,
      this.request.endDate
    ).then(response => {
      this.coincidences = response;
      this.loaded = true;
    }).finally(() => this.loadingMobileService.hide());
  }

  isLoaded() {
    return this.loaded === true;
  }

  showCoincidences() {
    return this.coincidences.length > 0;
  }

}

export default TeamRequestCoincidencesMobileController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCardDetails/teamRequestCoincidencesMobile/teamRequestCoincidencesMobile.controller.js